import { PATH_ASSETS, PATH_BASE } from './AppConstants';

export default class AppUrls {
  constructor(game) {
    this.game = game;
  }

  // get main directory
  getBaseDirectory() {
    return PATH_BASE;
  }

  // resolves relativly given url
  resolveRelatveUrl(path) {
    return this.getBaseDirectory() + path;
  }

  // get the root of the assets folder, pass in relative url for extended path
  getAssetsDirectory(url_suffix) {
    return url_suffix ? this.resolveRelatveUrl(PATH_ASSETS + url_suffix) : this.resolveRelatveUrl(PATH_ASSETS);
  }

  getFontsDirectory(url_suffix) {
    return this.getAssetsDirectory('fonts/' + url_suffix);
  }
}
